import { Component, AfterViewInit, Input, Output, EventEmitter, NgZone } from "@angular/core";
import { environment } from 'environments/environment';
import { logging } from 'protractor';

declare var gapi;

@Component({
  selector: 'ga-login-button',
  templateUrl: './ga-login-button.component.html'
})
export class GALoginButtonComponent {

  showLoginButton: boolean = false;
  _accessToken: string;

  @Input('gaView')
  gaView;

  @Output() gaViewChange = new EventEmitter();

  constructor(
    private zone: NgZone
  ) { }

  @Input('accessToken')
  set accessToken(accessToken: string) {
    this._accessToken = accessToken;
    this.showLoginButton = (accessToken == null);

    if (!this.showLoginButton) {
      this.login();
    }
  }

  get accessToken(): string {
    return this._accessToken;
  }

  login() {
    gapi.analytics.ready(() => {
      this.zone.run(() => {

        try {
          gapi.analytics.auth.authorize({
            serverAuth: {
              access_token: this.accessToken
            }
          });
          this.showLoginButton = false;
          var viewSelector = new gapi.analytics.ext.ViewSelector2({
            container: 'view-selector'
          });
          if (this.gaView) {
            viewSelector.set({ viewId: this.gaView.view.id })
          }
          console.log('this.accessToken', 'execute view selector');
          viewSelector.execute();
          viewSelector.on('viewChange', (data) => {
            console.log('this.accessToken', 'viewChange');
            this.zone.run(() => {
              this.gaView = data;
              console.log('gaView', this.gaView)
              this.gaViewChange.emit(this.gaView);
            });
          });
        } catch (e) {
          this.showLoginButton = true;
        }
      });
    });
  }
}
